// 习惯管理模块配置
export const habitsConfig = {
  // 模块基本信息
  name: '习惯管理',
  description: '养成、打卡、激励',
  icon: 'SyncOutlined',
  bgColor: '#F9E79F',
  iconColor: '#333333',
  
  // API 端点
  apiEndpoints: {
    habits: '/habits',
    create: '/habits',
    update: '/habits',
    delete: '/habits',
    progress: '/habits/progress',
    addProgress: '/habits/progress',
    deleteProgress: '/habits/progress',
    checkins: '/habits/checkins',
    createCheckin: '/habits/checkins',
    updateCheckin: '/habits/checkins',
    deleteCheckin: '/habits/checkins',
    stats: '/habits/stats',
    // 好习惯相关API
    goodHabits: '/habits/good-habits',
    createGoodHabit: '/habits/good-habits',
    updateGoodHabit: '/habits/good-habits',
    deleteGoodHabit: '/habits/good-habits'
  },
  
  // 习惯类型
  habitTypes: [
    {
      key: 'health',
      name: '健康习惯',
      icon: '🏃',
      color: '#52C41A',
      description: '运动、饮食、睡眠等健康相关习惯'
    },
    {
      key: 'study',
      name: '学习习惯',
      icon: '📚',
      color: '#1890FF',
      description: '阅读、学习、技能提升等学习相关习惯'
    },
    {
      key: 'work',
      name: '工作习惯',
      icon: '💼',
      color: '#FAAD14',
      description: '时间管理、效率提升等工作相关习惯'
    },
    {
      key: 'social',
      name: '社交习惯',
      icon: '👥',
      color: '#722ED1',
      description: '人际关系、沟通交流等社交相关习惯'
    },
    {
      key: 'life',
      name: '生活习惯',
      icon: '🏠',
      color: '#13C2C2',
      description: '日常生活、个人管理等生活相关习惯'
    },
    {
      key: 'finance',
      name: '理财习惯',
      icon: '💰',
      color: '#FF6B6B',
      description: '储蓄、投资、消费等理财相关习惯'
    }
  ],
  
  // 习惯状态
  habitStatus: [
    {
      key: 'active',
      name: '进行中',
      color: '#52C41A',
      description: '习惯正在培养中'
    },
    {
      key: 'completed',
      name: '已养成',
      color: '#1890FF',
      description: '习惯已经养成'
    },
    {
      key: 'paused',
      name: '暂停中',
      color: '#FAAD14',
      description: '习惯暂时停止培养'
    },
    {
      key: 'failed',
      name: '已放弃',
      color: '#FF4D4F',
      description: '习惯培养失败'
    }
  ],
  
  // 纠正难度
  difficultyLevels: [
    {
      key: 'easy',
      name: '容易',
      color: '#52C41A',
      description: '容易纠正，影响较小'
    },
    {
      key: 'medium',
      name: '中等',
      color: '#FAAD14',
      description: '有一定难度，需要努力'
    },
    {
      key: 'hard',
      name: '困难',
      color: '#FF4D4F',
      description: '很难纠正，影响较大'
    }
  ],
  
  // 习惯打卡选项
  checkinOptions: [
    {
      key: 'water_intake',
      question: '是否喝够8杯水?',
      category: 'health',
      icon: '💧',
      color: '#1890FF',
      description: '保持身体水分，促进新陈代谢'
    },
    {
      key: 'exercise',
      question: '是否运动30分钟以上?',
      category: 'health',
      icon: '🏃',
      color: '#52C41A',
      description: '增强体质，提高免疫力'
    },
    {
      key: 'reading',
      question: '是否阅读10页以上书籍?',
      category: 'study',
      icon: '📖',
      color: '#722ED1',
      description: '增长知识，提升思维能力'
    },
    {
      key: 'early_rise',
      question: '是否6点30早起?',
      category: 'life',
      icon: '🌅',
      color: '#FAAD14',
      description: '规律作息，提高时间利用率'
    },
    {
      key: 'early_sleep',
      question: '是否11点前睡觉?',
      category: 'health',
      icon: '😴',
      color: '#13C2C2',
      description: '保证充足睡眠，恢复精力'
    },
    {
      key: 'social_contact',
      question: '是否和朋友保持联络?',
      category: 'social',
      icon: '👥',
      color: '#FF6B6B',
      description: '维护人际关系，增进感情'
    }
  ],
  
  // 习惯养成周期
  habitFormationPeriods: {
    title: '习惯养成周期',
    description: '根据科学研究，不同习惯的养成需要不同的时间',
    periods: [
      {
        period: '7天',
        description: '简单习惯',
        examples: '每天喝水、整理桌面',
        color: '#52C41A'
      },
      {
        period: '21天',
        description: '基础习惯',
        examples: '早起、运动、阅读',
        color: '#1890FF'
      },
      {
        period: '66天',
        description: '复杂习惯',
        examples: '学习新技能、改变思维方式',
        color: '#FAAD14'
      },
      {
        period: '100天',
        description: '深度习惯',
        examples: '彻底改变生活方式、建立新身份',
        color: '#722ED1'
      }
    ]
  },
  
  // 习惯管理TIPS
  habitManagementTips: {
    title: '习惯管理TIPS',
    tips: [
      {
        title: '明确目标',
        description: '设定具体、可衡量的习惯目标',
        example: '每天阅读30分钟，而不是"多读书"'
      },
      {
        title: '循序渐进',
        description: '从简单习惯开始，逐步增加难度',
        example: '先养成每天喝水的习惯，再培养运动习惯'
      },
      {
        title: '环境设计',
        description: '创造有利于习惯养成的环境',
        example: '把书放在床头，把运动鞋放在门口'
      },
      {
        title: '习惯叠加',
        description: '将新习惯与已有习惯结合',
        example: '刷牙后立即喝水，睡前立即阅读'
      },
      {
        title: '及时奖励',
        description: '完成习惯后给予自己奖励',
        example: '连续7天早起后，奖励自己一顿美食'
      },
      {
        title: '记录追踪',
        description: '记录习惯执行情况，及时调整',
        example: '使用打卡日历，可视化习惯养成进度'
      }
    ]
  },
  
  // 习惯养成方法
  habitFormationMethods: {
    title: '习惯养成四大法则',
    methods: [
      {
        title: '让习惯显而易见',
        description: '通过环境设计让习惯更容易被触发',
        icon: '👁️',
        color: '#1890FF',
        examples: [
          '把运动装备放在显眼位置',
          '在手机上设置提醒',
          '在日历上标记习惯时间'
        ]
      },
      {
        title: '让习惯有吸引力',
        description: '将习惯与愉悦感联系起来',
        icon: '❤️',
        color: '#FF6B6B',
        examples: [
          '运动后听喜欢的音乐',
          '阅读后喝一杯咖啡',
          '完成习惯后给自己奖励'
        ]
      },
      {
        title: '让习惯容易执行',
        description: '降低习惯执行的难度和阻力',
        icon: '⚡',
        color: '#52C41A',
        examples: [
          '准备简单的运动装备',
          '选择容易阅读的书籍',
          '设定最小可行的目标'
        ]
      },
      {
        title: '让习惯令人满意',
        description: '让习惯执行后产生满足感',
        icon: '😊',
        color: '#FAAD14',
        examples: [
          '记录习惯完成情况',
          '分享习惯养成成果',
          '庆祝习惯养成里程碑'
        ]
      }
    ]
  },
  
  // 坏习惯纠正方法
  badHabitCorrection: {
    title: '坏习惯纠正方法',
    methods: [
      {
        title: '识别触发因素',
        description: '找出导致坏习惯的环境和情境',
        icon: '🔍',
        color: '#1890FF'
      },
      {
        title: '替代行为',
        description: '用好的行为替代坏习惯',
        icon: '🔄',
        color: '#52C41A'
      },
      {
        title: '环境改变',
        description: '改变环境减少坏习惯的触发',
        icon: '🏠',
        color: '#FAAD14'
      },
      {
        title: '渐进减少',
        description: '逐步减少坏习惯的频率',
        icon: '📉',
        color: '#722ED1'
      },
      {
        title: '寻求支持',
        description: '寻求朋友和家人的支持',
        icon: '🤝',
        color: '#13C2C2'
      }
    ]
  },
  
  // 习惯统计
  habitStats: {
    title: '习惯统计',
    stats: [
      {
        title: '连续打卡',
        key: 'streak',
        unit: '天',
        color: '#52C41A'
      },
      {
        title: '本月打卡',
        key: 'monthly',
        unit: '次',
        color: '#1890FF'
      },
      {
        title: '完成率',
        key: 'completion',
        unit: '%',
        color: '#FAAD14'
      },
      {
        title: '已养成',
        key: 'formed',
        unit: '个',
        color: '#722ED1'
      }
    ]
  }
};
